import React, { useState, useEffect } from 'react';
import { calculateDiffTime, transformDate } from 'utils/tool';

let timer: any = null;

interface IHookProps {
  initTime: number;
}

const CMP: React.FC<IHookProps> = ({ initTime }) => {
  const [time, setTime] = useState<number>(initTime);
  const [timeText, setTimeText] = useState<{
    hour: string | number;
    minute: string | number;
    second: string | number;
  }>({
    hour: '00',
    minute: '00',
    second: '00'
  });
  useEffect(() => {
    timer && clearInterval(timer);
    return () => {
      timer && clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    if (time === 0) {
      setTimeText({
        hour: '00',
        minute: '00',
        second: '00'
      });
    } else if (time > 0) {
      const { day, minute, second, hour } = calculateDiffTime(0, time);
      setTimeText({
        hour: transformDate(day * 24 + hour),
        minute: transformDate(minute),
        second: transformDate(second)
      });
    }
    if (time === initTime) {
      timer = setInterval(() => setTime((time) => --time), 1000);
    } else if (time <= 0) {
      clearInterval(timer);
    }
  }, [time]);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          color: '#F75959',
          width: '36px',
          height: '36px',
          borderRadius: '6px',
          textAlign: 'center',
          lineHeight: '36px',
          backgroundColor: '#fff'
        }}
      >
        {timeText.hour}
      </div>
      <div
        style={{
          margin: '0 6px',
          color: '#fff'
        }}
      >
        :
      </div>
      <div
        style={{
          color: '#F75959',
          width: '36px',
          height: '36px',
          borderRadius: '6px',
          textAlign: 'center',
          lineHeight: '36px',
          backgroundColor: '#fff'
        }}
      >
        {timeText.minute}
      </div>
      <div
        style={{
          margin: '0 6px',
          color: '#fff'
        }}
      >
        :
      </div>
      <div
        style={{
          color: '#F75959',
          width: '36px',
          height: '36px',
          borderRadius: '6px',
          textAlign: 'center',
          lineHeight: '36px',
          backgroundColor: '#fff'
        }}
      >
        {timeText.second}
      </div>
    </div>
  );
};

export default CMP;
